import {SectionPageComponent} from './section-page-component';
import {StringTransformer} from './string-transformer';

export class CourseRegistrationPageComponent extends SectionPageComponent<
  CourseRegistrationPageComponent,
  'courseRegistration'
> {
  constructor(el: any = {}) {
    super(
      el,
      'courseRegistration',
      {hasTitle: true, required: false},
      {hasText: false, required: false},
      ['Course'],
    );
  }

  public override toJson(): any {
    return {
      ...super.toJson(),
    };
  }

  public override getSearchKeys(): string[] {
    return ['sectionTitle'];
  }

  public override applyStringTransformer(
    transformer: StringTransformer,
  ): CourseRegistrationPageComponent {
    const res = new CourseRegistrationPageComponent(this.toJson());

    res.sectionTitle = transformer.transform(this.sectionTitle);

    return res;
  }
}
